function isNullish(value) {
  return value === null || value === void 0;
}
function notNullish(value) {
  return value !== null && value !== void 0;
}
export {
  isNullish,
  notNullish
};
